import React from 'react';
import { modals } from '@mantine/modals';
import { AuthModal } from '../components/login';

export const showAuthModal = () => {
  modals.open({
    title: null,
    size: 'auto',
    modalId: 'auth-modal',
    children: <AuthModal />,
    classNames: {
      root: 'pro-auth-modal',
    },
  });
};
